<template>
    <div class="main-box product-detail" :class="{'mask-layer':addSucceed}">
        <div class="box-header">
            <i class="el-icon-close" @click="$emit('close','productBuy')"></i>
            <span>Product Discussion Group </span>
        </div>
        <div class="box-content" :class="{isDiscussion:isDiscussion}">
            <scroll-wrap id="productBuy">
                <div class="box-content-wrap">
                    <div class="imglist">
                        <el-carousel trigger="click" height="328px">
                            <el-carousel-item v-for="item in product.attachments" :key="item">
                                <img :src="item" alt="">
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                    <div class="title">
                        {{product.title}}
                    </div>
                    <div class="store">
                        under discussion · · ·
                    </div>
                    <div class="discussion-group">
                        <div class="group-content" v-if="discussionGroup.length>0">
                            <div class="item" v-for="(item,index) in discussionGroup" :key="index"
                                 :class="{my:$store.state.user.id === item.sayer.id}">
                                <div class="line" :class="{active:lineActiev(index)}">
                                    —— {{new Date(item.createTime).$Format('yyyy-MM-dd hh:mm',true)}} ——
                                </div>
                                <div class="item-chat-wrap">
                                    <div class="item-portrait">
                                        <img :src="item.type===2?item.sayer.buyerImage:item.sayer.sellerImage" alt="">
                                    </div>
                                    <div class="item-content">
                                    <span class="sayer-name">
                                        {{item.type===2?item.sayer.buyer:item.sayer.sellerImage}}
                                    </span>
                                        <span class="sayer-txt">
                                        {{item.message}}
                                    </span>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div v-else class="warning">
                            There is no discussion at the moment, you can initiate the discussion first !
                        </div>
                    </div>

                </div>
            </scroll-wrap>
            <div class="message-alert" :class="{'active':addSucceed}">
                <div class="img">
                    <img :src="product.image" alt="">
                </div>
                <div class="txt">
                    Items Added to Cart
                </div>
                <div class="price">
                    You saved ${{product.price}}
                </div>
            </div>
        </div>
        <div class="box-footer">
            <div class="send-wrap">
                <input type="text" v-model="message" @keydown.enter="sendDiscuss">
                <i class="el-icon-s-promotion" @click="sendDiscuss"></i>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Product-Buy",
        props: {
            getProductBuy: [Object],
        },
        computed: {
            product: function () {
                return this.getProductBuy
            },
        },
        data() {
            return {
                collapseIndex: [],
                addSucceed: false,
                isDiscussion: false,
                message: '',
                discussionGroup: [],
                DISCUSSGROUP: null
            }
        },
        created() {
            this.discuss()
            this.DISCUSSGROUP = setInterval(() => {
                this.discuss(true)
            }, 1000)
        },
        destroyed() {
            clearInterval(this.DISCUSSGROUP)
        },
        methods: {
            lineActiev(index){
                if(index===0) return true
                return this.discussionGroup[index].createTime - this.discussionGroup[index - 1].createTime > 3600000;

            },
            discuss(toBottom) {
                let params = {
                    discuss: {
                        product: {
                            id: this.product.id
                        }
                    }
                }
                this.axios.post('/student/discuss/product/list', params).then(res => {
                    if (res.succeed) {
                        this.discussionGroup = res.items;
                        if (toBottom) return false;
                        this.$nextTick(() => {
                            setTimeout(() => {
                                document.querySelector("#productBuy").children[0].scrollTop =
                                    document.querySelector("#productBuy").children[0].scrollHeight -
                                    document.querySelector("#productBuy").children[0].clientHeight
                            }, 10)

                        })
                    }
                })
            },
            sendDiscuss() {
                if (this.message.trim() === '') return false
                let params = {
                    product: {
                        id: this.product.id
                    },
                    type: 2,
                    message: this.message
                }
                this.axios.post('/student/discuss/product/uploader', params).then(res => {
                    if (res.succeed) {
                        this.message = ""
                        this.discuss()
                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    div.main-box.product-detail {
        position: relative;
        overflow: hidden;
        border-radius: 0 0 20px 20px;

        &:before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            margin: auto;
            opacity: 0;
            background: rgba(0, 0, 0, 0.5);
            z-index: -1;
            border-radius: 0 0 20px 20px;
            transition: z-index 0s linear 0.3s, opacity 0.3s linear;
        }

        &.mask-layer:before {
            transition: z-index 0s linear 0s;
            opacity: 1;
            z-index: 2001;
        }

        div.box-header {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 52px;
            line-height: 52px;

            > i {
                position: absolute;
                top: 50%;
                left: 0;
                font-weight: bolder;
                transform: translateY(-50%);
                font-size: 18px;
                padding: 10px;
                cursor: pointer;

                &:hover {
                    opacity: 0.8;
                }
            }

            > span {
                font-size: 18px;
                color: #000000;
                font-weight: bolder;
            }
        }

        div.box-content {
            position: relative;
            height: calc(100% - 120px);


            div.box-content-wrap {
                div.imglist {
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }
                }

                div.title {
                    padding: 12px;
                    font-size: 14px;
                    margin-bottom: 8px;
                }

                div.store {
                    padding: 14px 8px;
                    background: #EEF6F8;
                    font-weight: bolder;
                    font-size: 16px;
                }

                div.discussion-group {
                    padding: 20px 8px;

                    div.group-content {
                        > div.item {
                            display: flex;
                            flex-direction: column;
                            padding: 0 8px;
                            box-sizing: border-box;
                            margin-bottom: 16px;

                            div.line {
                                width: 100%;
                                text-align: center;
                                font-size: 12px;
                                margin: 10px 0;
                                color: #9e9e9e;
                                display: none;
                                &.active {
                                    display: block;
                                }
                            }

                            div.item-chat-wrap {
                                display: flex;

                                div.item-portrait {
                                    width: 48px;
                                    height: 48px;
                                    border-radius: 50%;
                                    overflow: hidden;
                                    margin-right: 16px;

                                    img {
                                        width: 100%;
                                        height: 100%;
                                        object-fit: cover;
                                    }
                                }

                                div.item-content {
                                    display: flex;
                                    flex-direction: column;
                                    max-width: 70%;

                                    > .sayer-name {
                                        font-size: 12px;
                                        margin-bottom: 6px;
                                    }

                                    > .sayer-txt {
                                        background-color: #EFF1F5;
                                        border-radius: 6px;
                                        padding: 12px;
                                        word-break: break-all;
                                        font-size: 13px;
                                        line-height: 18px;
                                        letter-spacing: 0.6px;
                                    }
                                }

                            }

                            &.my {

                                div.item-chat-wrap {
                                    display: flex;
                                    flex-direction: row-reverse;
                                    div.item-portrait {
                                        margin-left: 16px;
                                        margin-right: 0;
                                    }

                                    div.item-content {
                                        > .sayer-name {
                                            text-align: right;
                                        }

                                        > .sayer-txt {
                                            text-align: right;
                                            background-color: #c7e6ff;
                                        }
                                    }
                                }

                            }

                        }
                    }
                    div.warning {
                        font-size: 14px;
                        font-weight: bolder;
                        color: #9E9E9E;
                        text-indent: 16px;
                    }

                    div.group-footer {
                        input {
                            outline: none;

                        }
                    }
                }

            }

            div.message-alert {
                width: 100%;
                padding: 20px 0;
                background: #FFFFFF;
                position: absolute;
                bottom: -300px;
                left: 0;
                z-index: 9999;
                transition: bottom 0.3s linear;
                border-radius: 0 0 22px 22px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                &.active {
                    bottom: -52px;
                    transition: bottom 0.3s linear;
                }

                > .img {
                    width: 80px;
                    height: 80px;
                    margin-bottom: 20px;

                    > img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }
                }

                > .txt {
                    font-weight: bolder;
                    margin-bottom: 10px;
                }

                > .price {
                    font-weight: lighter;
                    font-size: 12px;
                }
            }
        }

        div.box-footer {
            position: relative;

            div.send-wrap {
                width: 100%;
                height: 68px;
                display: flex;
                justify-content: center;
                align-items: center;
                box-sizing: border-box;
                background: #FFFFFF;
                border-radius: 0 0 20px 20px;
                border-top: 1px solid #EBEEF5;
                position: absolute;
                top: 100%;
                left: 0;
                z-index: 1;

                &.isDiscussion {
                    transition: top 0.3s ease-in-out;
                    position: relative;
                    top: 0;
                    z-index: 1;
                }

                > input {
                    width: 80%;
                    outline: none;
                    border: none;
                    background: #F1F1F1;
                    height: 36px;
                    line-height: 36px;
                    border-radius: 36px;
                    margin-right: 2%;
                    font-size: 12px;
                    padding: 0 16px;
                    box-sizing: border-box;
                }

                > i {
                    width: 36px;
                    height: 36px;
                    line-height: 36px;
                    text-align: center;
                    color: #ffffff;
                    background: #FDAD53;
                    cursor: pointer;
                    border-radius: 50%;
                    transition: background-color 0.3s ease-in-out;

                    &:hover {
                        background: #F44336;
                        transition: background-color 0.3s ease-in-out;
                    }
                }
            }

            div.buy-wrap {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 12px;
                box-sizing: border-box;
                height: 52px;
                border-top: 1px solid #dee1e9;

                div.price-wrap {
                    span.price {
                        color: #F44336;
                        font-weight: bolder;
                        font-size: 22px;
                    }

                    span.msrp {
                        text-decoration: line-through;
                        color: #9F9FA0;
                        font-size: 14px;
                    }
                }

                div.buy-btn {
                    span {
                        color: #FFFFFF;
                        font-weight: bolder;
                        font-size: 18px;
                        border-radius: 10px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100px;
                        height: 36px;
                        background: #FDAD53;
                        cursor: pointer;
                        transition: background 0.3s linear;

                        &:hover {
                            background: #ff8700;
                            transition: background 0.3s linear;
                        }
                    }
                }
            }
        }
    }
</style>
